export default "__VITE_ASSET__B9j5W6Xg__";